<!--
 * @Author: DY
 * @Date: 2023-09-07 16:00:31
 * @LastEditTime: 2025-01-03 16:10:35
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\reportForm\MonthlyPurchasingReport\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="costPage">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section>
                <div class="header">
                    <van-radio-group v-model="radio" direction="horizontal" @change="switchingTimeNodes">
                        <van-radio name="1">
                            按月
                            <template #icon="props">
                                <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                            </template>
                        </van-radio>
                        <van-radio name="0">
                            按财务月
                            <template #icon="props">
                                <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                            </template>
                        </van-radio>
                        <!-- <van-radio name="year">
                            按年查询
                            <template #icon="props">
                                <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                            </template>
                        </van-radio> -->
                    </van-radio-group>
                    <div class="search-conditions iconfont sm-rili" @click="handleShowDatePop('date')">
                        <span>{{ date }}</span>
                    </div>
                </div>
                <div class="main">
                    <div class="tableBox">
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="1" rowspan="2">
                                        <div class="table_div table_div_fl">
                                            分类
                                        </div>
                                    </th>
                                    <th colspan="1" rowspan="2">
                                        <div class="table_div">
                                            单位
                                        </div>
                                    </th>
                                    <th colspan="6">
                                        <div class="table_div_cgjg">
                                            采购价格
                                        </div>
                                    </th>
                                    <th colspan="1" rowspan="2">
                                        <div class="table_div">
                                            采购数量
                                        </div>
                                    </th>
                                    <th colspan="1" rowspan="2">
                                        <div class="table_div">
                                            采购金额
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="1">
                                        <div class="table_div">
                                            本月
                                        </div>
                                    </th>
                                    <th colspan="1">
                                        <div class="table_div">
                                            上月
                                        </div>
                                    </th>
                                    <th colspan="1">
                                        <div class="table_div">
                                            增减（%）
                                        </div>
                                    </th>
                                    <th colspan="1">
                                        <div class="table_div">
                                            本年
                                        </div>
                                    </th>
                                    <th colspan="1">
                                        <div class="table_div">
                                            去年
                                        </div>
                                    </th>
                                    <th colspan="1">
                                        <div class="table_div">
                                            增减（%）
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <template>
                                    <tr :key="`tableList_${index}`">
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                        <td colspan="1">
                                            <div class="table_div">111</div>
                                        </td>
                                    </tr>
                                </template> -->
                                <template v-for="(item, index) in dataList">
                                    <tr
                                        :key="`tableList_${index}`"
                                        :class="{active_tr: item.type_code === active_type_code}"
                                        @click="tableClickFun(item.type_code)"
                                    >
                                        <td>
                                            <div class="table_div table_div_fl">
                                                {{ item.type_name }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.unit }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.price_currmonth }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.price_lastmonth }}
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                :class="{ table_div: true, table_div_red: item.month_flag, table_div_green: !item.month_flag }"
                                            >
                                                {{ item.price_difference_month }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.price_curryear }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.price_lastyear }}
                                            </div>
                                        </td>
                                        <td>
                                            <div :class="{ table_div: true, table_div_red: item.year_flag, table_div_green: !item.year_flag }">
                                                {{ item.price_difference_year }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.quantity_currmonth }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="table_div">
                                                {{ item.money_currmonth }}
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="chart_tab_box">
                        <div class="tab" @click="chartTabClick('jg', 'price_lastyear', 'price_curryear')">
                            <div :class="{ tab_color_jg: true, active_tab: active_tab !== 'jg' }"></div>
                            <div class="tab_txt">
                                价格
                            </div>
                        </div>
                        <div class="tab tab_2" @click="chartTabClick('sl', 'quantity_lastyear', 'quantity_curryear')">
                            <div :class="{ tab_color_sl: true, active_tab: active_tab !== 'sl' }"></div>
                            <div class="tab_txt">
                                数量
                            </div>
                        </div>
                        <div class="tab" @click="chartTabClick('je', 'money_lastyear', 'money_curryear')">
                            <div :class="{ tab_color_je: true, active_tab: active_tab !== 'je' }"></div>
                            <div class="tab_txt">
                                金额
                            </div>
                        </div>
                    </div>
                    <div
                        class="chart"
                        id="chartBox"
                        ref="chartBox"
                        :style="{ height: chartHeight }"
                    >
                    </div>
                </div>
                <van-popup v-model="showDatePop" position="bottom" :style="{ height: '40%' }">
                    <template v-if="radio === '0' || radio === '1'">
                        <van-datetime-picker
                            v-model="dateModel"
                            type="year-month"
                            title="选择年月"
                            @confirm="confirmDate"
                            @cancel="showDatePop=false"
                        ></van-datetime-picker>
                    </template>
                    <!-- <template v-else>
                        <van-picker
                            show-toolbar
                            v-model="dateModel"
                            :columns="yearColumns"
                            @confirm="selectYear"
                            :default-index="currIndex"
                            @cancel="showDatePop=false"
                        ></van-picker>
                    </template> -->
                </van-popup>
            </section>
        </div>
    </v-touch>
</template>

<script>
import * as echarts from 'echarts';
import currencyFun from '@/assets/js/currencyFun/index.js';

export default {
    components: {},
    props: {},
    data() {
        return {
            active_type_code: '',
            active_tab: 'jg',
            chartBoxChart: null,
            chartRes: null,
            navData: {
                title: '',
                leftArrow: true,
            },
            radio: '1',

            showDatePop: false,
            date: '',
            dateModel: '',
            yearColumns: [],

            currIndex: 0,

            requestUrl: '',
            dataList: [
                // { type_name: '111' },
                // { type_name: '111' },
                // { type_name: '111' },
                // { type_name: '111' },
                // { type_name: '111' },
                // { type_name: '111' },
                // { type_name: '111' },
                // { type_name: '111' },
            ],
            chartHeight: '350px',
            key1: 'price_lastyear',
            key2: 'price_curryear',
        };
    },
    created() {
        const currentDate = new Date();
        const day = currentDate.getDate();
        if (day > 25) {
            this.date = currencyFun.timeFormat(new Date(), 'yyyy-MM');
            this.dateModel = new Date(currencyFun.timeFormat(new Date(), 'yyyy-MM'));
        } else {
            const month = currencyFun.prevMonth();
            this.date = currencyFun.timeFormat(new Date(month[0]), 'yyyy-MM');
            this.dateModel = new Date(currencyFun.timeFormat(new Date(month[0]), 'yyyy-MM'));
        }

    },
    mounted() {
        this.chartBoxChart = echarts.init(this.$refs.chartBox);
        this.initPage();
    },
    methods: {
        async initPage() {
            const res = await this.getDataList();
            res.forEach(item => {
                item.month_flag = item.price_difference_month >= 0;
                item.year_flag = item.price_difference_year >= 0;
                const month = item.price_difference_month;
                const year = item.price_difference_year;
                item.price_difference_month = month === 0 ? month : Math.abs(month) + '%';
                item.price_difference_year = year === 0 ? year : Math.abs(year) + '%';
            });
            this.dataList = res || [];
            this.active_type_code = res && res[0] ? res[0].type_code : '';
            this.chartRes = await this.getChartDataList();
            this.loadData(this.active_tab, 'price_lastyear', 'price_curryear');
        },
        async tableClickFun(type) {
            this.active_type_code = type;
            this.chartRes = await this.getChartDataList();
            this.loadData(this.active_tab, this.key1, this.key2);
        },
        chartTabClick(tab, key1, key2) {
            this.active_tab = tab;
            this.key1 = key1;
            this.key2 = key2;
            this.loadData(tab, key1, key2);
        },
        loadData(tab, key1, key2) {
            this.chartBoxChart.clear();
            const list1 = [];
            const list2 = [];
            const list3 = [];
            const list4 = [];
            const list5 = [];
            // const list1 = [10, 5, 9, 10, 10, 3, 10, 2, 10, 10, 5, 20];
            // const list2 = [11, 14, 133, 4, 0, 14, 116, 12, 12, 58, 15, 12];
            // const list3 = [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15];
            // const list4 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
            // const list5 = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            if (this.chartRes && this.chartRes.list && this.chartRes.list[0]) {
                this.chartRes.list.forEach(item => {
                    list1.push(item[key1]);
                    list2.push(item[key2]);
                    list5.push(item.month);
                    if (tab === 'jg') {
                        list3.push(this.chartRes.price_curryear || 0);
                        list4.push(this.chartRes.price_lastyear || 0);
                    }
                });
            }
            const chartData = {
                tooltip: {
                    trigger: 'item',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                grid: {
                    left: '2%',
                    right: '4%',
                    bottom: '14%',
                    top: '16%',
                    containLabel: true,
                },
                legend: {
                    data: ['去年', '本年', '本年平均', '去年平均'],
                    bottom: '5%',
                    left: 'center',
                    textStyle: {
                        color: '#666666',
                    },
                    itemWidth: 15,
                    itemHeight: 10,
                    itemGap: 25,
                },
                xAxis: {
                    type: 'category',
                    data: list5,
                    axisLine: {
                        lineStyle: {
                            color: '#cdd5e2',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#666666',
                        },
                    },
                },
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: '#cdd5e2',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#666666',
                        },
                    },
                }],
                series: [{
                    name: '去年',
                    type: 'bar',
                    barWidth: '8px',
                    itemStyle: {
                        normal: {
                            color: '#f0c178',
                        },
                    },
                    data: list1,
                }, {
                    name: '本年',
                    type: 'bar',
                    barWidth: '8px',
                    itemStyle: {
                        normal: {
                            color: '#a5f6fb',
                        },
                    },
                    data: list2,
                }],
            };
            if (tab === 'jg') {
                chartData.series.push({
                    name: '本年平均',
                    type: 'line',
                    smooth: false, // 平滑曲线显示
                    symbol: 'none', // 标记的图形为实心圆
                    symbolSize: 10, // 标记的大小
                    itemStyle: {
                        normal: {
                            color: '#364aec',
                            borderColor: 'rgba(255, 234, 0, 0.5)', // 圆点透明 边框
                            borderWidth: 8,
                        },
                    },
                    lineStyle: {
                        color: '#364aec',
                    },
                    data: list3,
                });
                chartData.series.push({
                    name: '去年平均',
                    type: 'line',
                    smooth: false, // 平滑曲线显示
                    symbol: 'none', // 标记的图形为实心圆
                    symbolSize: 10, // 标记的大小
                    itemStyle: {
                        normal: {
                            color: '#9eac83',
                            borderColor: '#9eac83', // 圆点透明 边框
                            borderWidth: 10,
                        },
                    },
                    lineStyle: {
                        color: '#9eac83',
                    },
                    data: list4,
                });
            }
            this.$nextTick(() => {
                this.chartBoxChart.setOption(chartData);
            });
        },
        // 时间节点切换
        switchingTimeNodes(val) {
            // this.date = currencyFun.timeFormat(new Date(), 'yyyy-MM');
            // this.dateModel = new Date(currencyFun.timeFormat(new Date(), 'yyyy-MM'));
            // if (val === '0') {
            //     this.date = currencyFun.timeFormat(new Date(), 'yyyy-MM');
            //     this.dateModel = new Date(currencyFun.timeFormat(new Date(), 'yyyy-MM'));
            // } else {
            //     this.date = currencyFun.timeFormat(new Date(), 'yyyy');
            //     this.dateModel = currencyFun.timeFormat(new Date(), 'yyyy');
            //     this.yearColumns.forEach((item, i) => {
            //         if (this.dateModel === item + '') {
            //             this.currIndex = i;
            //         }
            //     });
            // }
            this.initPage();
        },
        // 打开时间节点选择
        handleShowDatePop() {
            this.dateModel = new Date(this.date);
            this.showDatePop = true;
        },
        // 年月选择
        confirmDate(value) {
            this.date = currencyFun.timeFormat(value, 'yyyy-MM');
            this.showDatePop = false;
            this.initPage();
        },
        // 年选择
        // selectYear(value) {
        //     this.date = value;
        //     this.showDatePop = false;
        //     this.initPage();
        // },
        // 获取数据
        getDataList() {
            const path = `/interfaceApi/report/procurement/daily_report/month_summary/${this.$route.query.menuType}/${this.date}?month_type=${this.radio}`;
            return this.$axios.$get(path, this.queryDate, { defEx: true });
        },
        // 获取数据
        getChartDataList() {
            const menuType = this.$route.query.menuType;
            const path = `/interfaceApi/report/procurement/daily_report/month_summary/barchart/${menuType}/${this.active_type_code}/${this.date}?month_type=${this.radio}`;
            return this.$axios.$get(path, this.queryDate, { defEx: true });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
    },
};
</script>
<style lang="stylus" scoped>
.container
    height 100%
    section
        height calc(100% - 66rpx)
        .header
            height 52rpx
            background #F8F8F8
            border-bottom 1px solid #F0F0F0
            padding 0 14rpx
            display flex
            justify-content: space-between
            align-items: center
            >>>.van-radio-group
                .van-radio
                    display flex
                    align-items: center
                    margin-right: 20rpx
                    .van-radio__icon
                        width 14rpx
                        height 14rpx
                        display: flex;
                        align-items: center;
                        .iconfont
                            color #999999
                        &.van-radio__icon--checked
                            .iconfont
                                color #EB0003
                            &+.van-radio__label
                                color #EB0003
                    .van-radio__label
                        font-size 14rpx
                        color #999999
            .search-conditions
                width 120rpx
                height 32rpx
                line-height: 30rpx
                background: #F0F0F0;
                border-radius: 4px;
                border: 1px solid #D7D7D7;
                font-size 14rpx
                color #343434
                text-align: center
                position: relative
                padding-left: 20rpx
                display: flex;
                justify-content: center;
                align-items: center;
                &:before
                    position: absolute
                    top 0
                    left 10rpx
        .main
            height calc(100% - 52rpx)
            overflow-y: scroll
            .chart
                height: 350rpx
                margin-bottom 35rpx
            .chart_tab_box
                display flex
                justify-content center
                align-items center
                height 30rpx
                .tab
                    display flex
                    justify-content center
                    align-items center
                    cursor pointer
                    .active_tab
                            background #ccc !important
                    .tab_color_jg
                        background #f0c178
                        width 22rpx
                        height 16rpx
                        border-radius 4rpx
                        margin-right 4rpx
                    .tab_color_sl
                        background #a5f6fb
                        width 22rpx
                        height 16rpx
                        border-radius 4rpx
                        margin-right 4rpx
                    .tab_color_je
                        background #364aec
                        width 22rpx
                        height 16rpx
                        border-radius 4rpx
                        margin-right 4rpx
                .tab_2
                    margin 0 6rpx
            .tableBox
                width 100%
                overflow-x auto
                padding 14rpx
                margin-bottom 8rpx
                table
                    width 100%
                    border-collapse: collapse
                    th,td
                        height: 32rpx
                        color #343434
                        font-size 14rpx
                        border 1px solid #E4E4E4
                        text-align: center
                        .table_div
                            width 60rpx
                            padding 0 2rpx
                        .table_div_red
                            color #a05134
                        .table_div_green
                            color #91b252
                        .table_div_fl
                            min-width 160rpx
                        .table_div_cgjg
                            width 240rpx
                    .active_tr
                        background #d8a053 !important
                        td
                            background #d8a053 !important
                    th
                        background: #FBEEEE
                        border-color #EAD9D9
</style>
